var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin2Line = function SvgMapPin2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.228 16.828 12.5 22.555l-5.728-5.727a8.1 8.1 0 1 1 11.456 0M12.5 12.9a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
  })));
};
export default SvgMapPin2Line;